import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useMaintenanceTypesApi } from "../../../http/maintenanceTypes/api";
import ModalDialog from "../../ui/ModalDialog";

interface DeleteMaintenanceTypeDialogProps {
  maintenanceTypeId: string;
  onClose: () => void;
}

const DeleteMaintenanceTypeDialog: FC<DeleteMaintenanceTypeDialogProps> = ({ maintenanceTypeId, onClose }) => {
  const i18n = useI18n();
  const maintenanceTypesApi = useMaintenanceTypesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.maintenanceTypes.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            maintenanceTypesApi
              .deleteAdminMaintenanceType(maintenanceTypeId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.maintenanceTypes.questions.delete}
    </ModalDialog>
  );
};

export default DeleteMaintenanceTypeDialog;
